import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import IconBtn from '../../components/ui/IconBtn';
import Badge from '../../components/ui/Badge';
import Secao from '../../components/ui/Secao';
import { ordensCompraApi } from '../../api/compras';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import { useAuth } from '../../context/AuthContext';

const STATUS_TOM = { aberta: 'info', parcial: 'aviso', atendida: 'sucesso', cancelada: 'perigo' };
const STATUS_LABEL = { aberta: 'Aberta', parcial: 'Parcialmente Recebida', atendida: 'Atendida', cancelada: 'Cancelada' };

export default function OrdemCompraDetail({ ordemCompraId, onVoltar, onAbrirNota }) {
  const { empresaAtual } = useAuth();
  const [oc, setOc] = useState(null);

  const carregar = () => ordensCompraApi.obter(ordemCompraId).then(setOc).catch(() => {});
  useEffect(() => { carregar(); }, [ordemCompraId]); // eslint-disable-line

  useTituloPagina(oc ? `Ordem de Compra #${oc.numero}` : 'Ordem de Compra');

  const cancelar = async () => {
    if (!window.confirm('Cancelar esta ordem de compra?')) return;
    await ordensCompraApi.cancelar(ordemCompraId);
    carregar();
  };

  const imprimir = () => {
    const janela = window.open('', '_blank');
    janela.document.write(`<!DOCTYPE html><html><head><title>Ordem de Compra #${oc.numero}</title>
      <meta charset="utf-8" />
      <style>
        body { font-family: Arial, sans-serif; color: #0f172a; padding: 24px; }
        h2 { margin: 0; font-size: 18px; }
        h3 { font-size: 13px; margin-bottom: 6px; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: 16px; }
        th { text-align: left; border-bottom: 1.5px solid #000; padding: 4px 6px; }
        td { padding: 4px 6px; border-bottom: 1px solid #ccc; }
        .cabecalho { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #000; padding-bottom: 12px; margin-bottom: 16px; }
        .direita { text-align: right; }
        .fornecedor { font-size: 12px; margin-bottom: 16px; line-height: 1.6; }
        .total { text-align: right; font-weight: 700; padding: 6px; }
      </style>
      </head><body>
      <div class="cabecalho">
        <div style="display:flex; align-items:flex-start; gap:12px;">
          ${empresaAtual?.logo_url ? `<img src="${window.location.origin}${empresaAtual.logo_url}" alt="Logo" style="max-width:90px; max-height:70px; object-fit:contain;" />` : ''}
          <div>
            <h2>${empresaAtual?.nome || 'Empresa'}</h2>
            ${empresaAtual?.razao_social ? `<div style="font-size:12px">${empresaAtual.razao_social}</div>` : ''}
            ${empresaAtual?.cnpj ? `<div style="font-size:12px">CNPJ: ${empresaAtual.cnpj}</div>` : ''}
            ${(empresaAtual?.municipio || empresaAtual?.uf) ? `<div style="font-size:12px">${empresaAtual?.municipio || ''}${empresaAtual?.municipio && empresaAtual?.uf ? ' / ' : ''}${empresaAtual?.uf || ''}</div>` : ''}
          </div>
        </div>
        <div class="direita">
          <h2>Ordem de Compra #${oc.numero}</h2>
          <div style="font-size:12px">Emitida em: ${new Date(oc.criado_em).toLocaleDateString('pt-BR')}</div>
          <div style="font-size:12px">Status: ${STATUS_LABEL[oc.status]}</div>
          <div style="font-size:12px">Comprador: ${oc.usuario_nome || '-'}</div>
          <div style="font-size:12px">Condição de Pagamento: ${oc.condicao_pagamento_nome || '-'}</div>
        </div>
      </div>

      <h3>Fornecedor</h3>
      <div class="fornecedor">
        <div><strong>${oc.fornecedor_nome}</strong>${oc.fornecedor_razao_social ? ` — ${oc.fornecedor_razao_social}` : ''}</div>
        <div>${oc.fornecedor_cnpj ? `CNPJ: ${oc.fornecedor_cnpj}` : ''}${oc.fornecedor_ie ? `  ·  IE: ${oc.fornecedor_ie}` : ''}</div>
        ${(oc.fornecedor_logradouro || oc.fornecedor_cidade) ? `<div>${oc.fornecedor_logradouro || ''}${oc.fornecedor_numero ? `, ${oc.fornecedor_numero}` : ''}${oc.fornecedor_bairro ? ` — ${oc.fornecedor_bairro}` : ''}${oc.fornecedor_cidade ? `, ${oc.fornecedor_cidade}` : ''}${oc.fornecedor_uf ? `/${oc.fornecedor_uf}` : ''}</div>` : ''}
        <div>${oc.fornecedor_contato_nome ? `Contato: ${oc.fornecedor_contato_nome}` : ''}${oc.fornecedor_telefone ? `  ·  Tel: ${oc.fornecedor_telefone}` : ''}${oc.fornecedor_email ? `  ·  ${oc.fornecedor_email}` : ''}</div>
        ${oc.fornecedor_prazo_entrega ? `<div>Prazo médio de entrega: ${oc.fornecedor_prazo_entrega} dias</div>` : ''}
      </div>

      <h3>Itens</h3>
      <table>
        <thead><tr><th>Produto</th><th>Qtd.</th><th>Custo Unit.</th><th>Subtotal</th></tr></thead>
        <tbody>
          ${oc.itens.map(item => `<tr>
            <td>${item.produto_codigo} - ${item.produto_nome}</td>
            <td>${item.quantidade}</td>
            <td>${item.custo_unitario_esperado ? `R$ ${Number(item.custo_unitario_esperado).toFixed(2)}` : '-'}</td>
            <td>${item.custo_unitario_esperado ? `R$ ${(Number(item.custo_unitario_esperado) * Number(item.quantidade)).toFixed(2)}` : '-'}</td>
          </tr>`).join('')}
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="total">Total Estimado</td>
            <td class="total">R$ ${oc.itens.reduce((soma, item) => soma + (Number(item.custo_unitario_esperado || 0) * Number(item.quantidade)), 0).toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>

      ${oc.observacoes ? `<h3>Observações</h3><p style="font-size:12px">${oc.observacoes}</p>` : ''}
      </body></html>`);
    janela.document.close();
    janela.onload = () => { janela.focus(); janela.print(); };
  };

  if (!oc) return null;

  return (
    <div>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <strong style={{ fontSize: 15 }}>Fornecedor: {oc.fornecedor_nome}</strong>
            <Badge tom={STATUS_TOM[oc.status]}>{STATUS_LABEL[oc.status]}</Badge>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
            <IconBtn titulo="Imprimir Ordem de Compra" variante="ghost" onClick={imprimir}>
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 6 2 18 2 18 9" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" />
              </svg>
            </IconBtn>
            {['aberta', 'parcial'].includes(oc.status) && <Btn variante="danger" onClick={cancelar}>Cancelar OC</Btn>}
          </div>
        </div>

        <Secao titulo="Dados da Ordem de Compra">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, fontSize: 13, marginBottom: 4 }}>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Data de Emissão</div>{new Date(oc.criado_em).toLocaleDateString('pt-BR')}</div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Comprador</div>{oc.usuario_nome || '-'}</div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Prazo Médio de Entrega</div>{oc.fornecedor_prazo_entrega ? `${oc.fornecedor_prazo_entrega} dias` : '-'}</div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Condição de Pagamento</div>{oc.condicao_pagamento_nome || '-'}</div>
            <div style={{ gridColumn: '1 / -1' }}>
              <div style={{ color: COLORS.textMid, fontSize: 11 }}>Endereço do Fornecedor</div>
              {(oc.fornecedor_logradouro || oc.fornecedor_cidade) ? (
                <span>
                  {oc.fornecedor_logradouro}{oc.fornecedor_numero ? `, ${oc.fornecedor_numero}` : ''}
                  {oc.fornecedor_bairro ? ` — ${oc.fornecedor_bairro}` : ''}
                  {oc.fornecedor_cidade ? `, ${oc.fornecedor_cidade}` : ''}{oc.fornecedor_uf ? `/${oc.fornecedor_uf}` : ''}
                </span>
              ) : '-'}
            </div>
            <div>
              <div style={{ color: COLORS.textMid, fontSize: 11 }}>CNPJ / IE do Fornecedor</div>
              {oc.fornecedor_cnpj || '-'}{oc.fornecedor_ie ? ` · IE ${oc.fornecedor_ie}` : ''}
            </div>
            <div>
              <div style={{ color: COLORS.textMid, fontSize: 11 }}>Contato do Fornecedor</div>
              {oc.fornecedor_contato_nome || '-'}{oc.fornecedor_telefone ? ` · ${oc.fornecedor_telefone}` : ''}
            </div>
            <div>
              <div style={{ color: COLORS.textMid, fontSize: 11 }}>E-mail do Fornecedor</div>
              {oc.fornecedor_email || '-'}
            </div>
          </div>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Itens">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 8 }}>Produto</th>
                <th style={{ padding: 8 }}>Qtd. Pedida</th>
                <th style={{ padding: 8 }}>Qtd. Recebida</th>
                <th style={{ padding: 8 }}>Custo Esperado</th>
              </tr>
            </thead>
            <tbody>
              {oc.itens.map(item => (
                <tr key={item.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 8 }}>{item.produto_codigo} - {item.produto_nome}</td>
                  <td style={{ padding: 8 }}>{item.quantidade}</td>
                  <td style={{ padding: 8 }}>{item.quantidade_recebida}</td>
                  <td style={{ padding: 8 }}>{item.custo_unitario_esperado ? `R$ ${Number(item.custo_unitario_esperado).toFixed(2)}` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Notas de Entrada Anexadas">
          {oc.notas.length === 0 ? (
            <p style={{ color: COLORS.textMid, fontSize: 13 }}>Nenhuma nota anexada ainda.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {oc.notas.map(n => (
                <div key={n.id} onClick={() => onAbrirNota(n.id)}
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 12px', border: `1px solid ${COLORS.border}`, borderRadius: 8, cursor: 'pointer' }}>
                  <span>NF {n.numero || '-'}/{n.serie || '-'} — {n.data_emissao ? new Date(n.data_emissao).toLocaleDateString('pt-BR') : '-'}</span>
                  <strong>R$ {Number(n.valor_total || 0).toFixed(2)}</strong>
                </div>
              ))}
            </div>
          )}
        </Secao>

        {oc.observacoes && (
          <>
            <div style={{ height: 14 }} />
            <Secao titulo="Observações">
              <p style={{ fontSize: 13, color: COLORS.text, margin: 0 }}>{oc.observacoes}</p>
            </Secao>
          </>
        )}
      </Card>
    </div>
  );
}
